module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAAAXNSR0IArs4c6QAAAMpJREFUSA3N1L0RQiEMAOCHW9k5haV3FtBbuoBD8B6thZWtnRu4EAcmAwTy550pIckH3JFlISLn/FnX9UBsi5d3VEUI4dJ7f3hhgYJwHRHEAD3GGN+j3NneEMJiL2wKeWEsyANjQ1ZMBFkwMaTFVJAGU0NSzARJMHIEYRNO4MSAyXFrrd1H+WaolLIH5ArYeQSZng6RWusTkFNK6fUTSILgAVQ3kiIqSIOIIS0igiwIG7IiLMgDmUJeyBDyRBAiRxD8+I3z47HJX8UXyyC80i76hH8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/static/images/common_icon_next.png
// module id = 849
// module chunks = 127